<template>
    <section class="interview-title light green">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-inge-walid.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light green">
                    <h3>Interview Inge&nbsp;Vincentie&nbsp;& Walid&nbsp;Essakkati</h3>
                    <h2>STAP 013: Het onderwijs verbeteren kun je niet zonder studenten</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .bg{
        background-position-y:100% !important;
    }
</style>

<script>
    import InterviewIngeWalid from '@/app/pages/sub/InterviewIngeWalid';

    export default {
        name: 'DuurzaamInterview',
        meta: {
            title: 'DuurzaamInterview',
            color: '#12C470'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewIngeWalid );
            }
        }
    };
</script>
